import React from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../utils/AuthContext';
import {
  PRODUCT_FEDERATION,
  PRODUCT_POST_MATCH,
  orgCanAccessFederation,
  orgCanAccessPostMatch,
  setStoredProduct,
} from '../utils/productWorkspace';

export default function ChooseProduct() {
  const { org, loading } = useAuth();
  const navigate = useNavigate();
  const federation = orgCanAccessFederation(org);
  const postMatch = orgCanAccessPostMatch(org);

  if (loading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <p className="text-gray-400 text-sm">Loading…</p>
      </div>
    );
  }

  if (!federation || !postMatch) {
    return <Navigate to={federation ? '/federation/dashboard' : '/dashboard'} replace />;
  }

  const choose = (product) => {
    setStoredProduct(product);
    navigate(product === PRODUCT_FEDERATION ? '/federation/dashboard' : '/dashboard', { replace: true });
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white flex items-center justify-center px-4 py-16">
      <div className="w-full max-w-2xl">
        <p className="text-navy-600 text-xs font-semibold tracking-widest uppercase mb-2">Tactmark</p>
        <h1 className="font-serif text-3xl text-navy-900 mb-2">Choose your workspace</h1>
        <p className="text-gray-600 text-sm mb-8">
          This organization has access to both products. Pick where to continue — you can switch anytime from the navigation.
        </p>
        <div className="grid gap-4 sm:grid-cols-2">
          <button
            type="button"
            onClick={() => choose(PRODUCT_POST_MATCH)}
            className="text-left border border-navy-200 bg-white hover:border-navy-900 rounded-xl p-6 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-navy-400"
          >
            <h2 className="font-semibold text-navy-900 text-lg mb-2">Tactmark Post-Match</h2>
            <p className="text-sm text-gray-600">Team-level completed-match review and coaching decisions.</p>
          </button>
          <button
            type="button"
            onClick={() => choose(PRODUCT_FEDERATION)}
            className="text-left border border-navy-200 bg-white hover:border-navy-900 rounded-xl p-6 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-navy-400"
          >
            <h2 className="font-semibold text-navy-900 text-lg mb-2">Tactmark Federation</h2>
            <p className="text-sm text-gray-600">Organization-level technical development, programs, and accountability.</p>
          </button>
        </div>
        <p className="text-xs text-gray-500 mt-6">
          Prefer a bookmark? Open <Link className="underline text-navy-800" to="/dashboard">Post-Match</Link>
          {' '}or <Link className="underline text-navy-800" to="/federation/dashboard">Federation</Link> directly.
        </p>
      </div>
    </div>
  );
}
